import o from "localforage";
import { StorageKeyEnum as t } from "../const/StorageKeyEnum.js";
async function a() {
  return !!await o.getItem(t.ADMIN_TOKEN);
}
export {
  a as hasToken
};
